import React from 'react';
import styles from './SideBar.module.css';

const LogoSection = ({ isOpen, portalInfo }) => {
    return (
        <div className={styles.logoSection}>
            <div className={styles.logoWrapper}>
                {isOpen && (
                    <div className={styles.logoText}>
                        <span className={styles.logoTitle}>{portalInfo.title}</span>
                        <span className={styles.logoSubtitle}>{portalInfo.subtitle}</span>
                    </div>
                )}
            </div>
        </div>
    );
};

export default LogoSection;